export enum PortfolioTab {
	Portfolio = 0,
	Documents = 1,
}

export const PORTFOLIO_TAB_STORAGE_KEY = "portfolio-tab";
